import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import EMARReport from "./CareManagementReports/EMARReport";

export default function CareManagement_Reports(props) {
    const [activeKey, setActiveKey] = useState("emar");

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%', position: 'absolute' }}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    Care Management Reports
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                        width: 'inherit'
                    }}
                >
                    <Tab key="emar" value="emar" label="eMAR" />
                </Tabs>

                <div style={{ width: '100%' }}>
                    {activeKey === "emar" && <EMARReport {...props} />}
                </div>
            </div>
        </div>
    )
};
